<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <p class="text-center">{{ 'message.get-invite-success' | translate }}</p>
  <div class="d-flex align-items-center justify-content-center p-3">
    <i class="bi bi-check-circle-fill fs-1"></i>
  </div>
</div>
